import React, { useEffect, useState } from "react";
import Header from "components/Header/Header.js";
import BottomFooter from "components/Footer/BottomFooter.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import { colors } from "../components/Theme/WebTheme";
import LandingInfo from "../components/LandingInfo";
import VideoBg from "../components/VideoBg";

import { useSelector } from "react-redux";

const dashboardRoutes = [];

export default function LandingPage(props) {
  const auth = useSelector((state) => state.auth);

  const { ...rest } = props;

  return (
    <div
      style={{
        // width: "100%",
        height: "auto",
        padding: "0px",
        margin: "0px",
      }}
    >
      <VideoBg />
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />

      <LandingInfo />

      <BottomFooter />
    </div>
  );
}
